import * as c from '../constants';
import { getProfile, getCountries } from '../../profile/actions';
import { onWaiting } from '../../Actions';

export function isLoading(isLoading) {
    return {
        type: c.BILLING_LOADING,
        isLoading
    }
}

export const getProfileInfo = () => {
    return dispatch => {
        dispatch(getProfile());
        dispatch(getCountries());
    }
}      

export const payment = (data) => {
    return (dispatch, getState, { alert, api, history }) => {
        dispatch(onWaiting(true));
        api.post('/payment', data, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return;
                const { message } = response;
                alert.success(message);
                history.push('/process-success');
            })
    }
}


// WEBPACK FOOTER //
// ./src/billing/actions/index.js